module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.chapter) ? _c('cover-image', {
    staticClass: "no-margin",
    attrs: {
      "src": _vm.chapter.image,
      "title": _vm.chapter.chapterTranslations[0].title,
      "subtitle": _vm.chapter.chapterTranslations[0].editor,
      "type": 'landing',
      "editorGender": _vm.chapter.chapterTranslations[0].editorGender
    }
  }) : _vm._e(), _vm._v(" "), _c('chapter-picker', {
    attrs: {
      "name": 'chapter',
      "items": _vm.chapters,
      "language": _vm.language,
      "initialItem": _vm.chapter
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "articles container-fluid"
  }, [_c('div', {
    attrs: {
      "id": "line"
    }
  }), _vm._v(" "), _vm._l((_vm.articles), function(article, index) {
    return _c('div', {
      key: article.id,
      staticClass: "row"
    }, [_c('article-card', {
      staticClass: "col-md-6",
      class: _vm.getClassesForArticle(index),
      attrs: {
        "data-id": article.id,
        "article": article,
        "published": _vm.checkArticlePublishDate(article.publishDate),
        "orientation": _vm.isOddIndex(index) ? 'left' : 'right',
        "inFeed": true
      }
    })], 1)
  })], 2), _vm._v(" "), (_vm.relatedResearch) ? _c('div', {
    staticClass: "container-fluid text-center section white",
    attrs: {
      "id": "related"
    }
  }, [_c('h4', {
    staticClass: "section-title"
  }, [_vm._v("Related research")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container-fluid text-center section",
    attrs: {
      "id": "newsletter"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "section-title col-12"
  }, [_vm._v(_vm._s(_vm.$t('title.newsletter')))]), _vm._v(" "), _c('p', {
    staticClass: "col-12"
  }, [_vm._v(_vm._s(_vm.$t('text.newsletter')))]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "input-group col-md-6 offset-md-3"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('placeholder.email')
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-green",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.send')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section white",
    attrs: {
      "id": "built"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.chapter.position < 15) ? _c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "section-title text-center col-12"
  }, [_vm._v(_vm._s(_vm.$t('title.built')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row logos"
  }, [(_vm.chapter.position < 15) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    attrs: {
      "href": "http://www.secons.net",
      "target": "_blank"
    }
  }, [(_vm.language === 'en') ? _c('img', {
    attrs: {
      "src": "static/logos/secons.png",
      "alt": "SeConS"
    }
  }) : _c('img', {
    attrs: {
      "src": "static/logos/secons-sr.png",
      "alt": "SeConS"
    }
  })])])])]) : _c('div', {
    staticClass: "col-md-6 offset-md-3"
  }, [_c('a', {
    attrs: {
      "href": "http://www.secons.net",
      "target": "_blank"
    }
  }, [(_vm.language === 'en') ? _c('img', {
    attrs: {
      "src": "static/logos/secons.png",
      "alt": "SeConS"
    }
  }) : _c('img', {
    attrs: {
      "src": "static/logos/secons-sr.png",
      "alt": "SeConS"
    }
  })])])]), _vm._v(" "), ([9, 11, 12, 13].indexOf(_vm.chapter.position) !== -1) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "section-title text-center col-12"
  }, [_vm._v(_vm._s(_vm.$t('title.supported')))])]), _vm._v(" "), _c('div', {
    staticClass: "row logos"
  }, [_c('div', {
    staticClass: "col-12 mt-4"
  }, [(_vm.chapter != null && _vm.chapter.position === 9) ? _c('a', {
    attrs: {
      "href": "http://www.fes-serbia.org",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/fes.png",
      "alt": "Friedrich Ebert Stiftung"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.chapter != null && _vm.chapter.position === 11) ? _c('a', {
    attrs: {
      "href": "http://www.osce.org",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/osce.png",
      "alt": "OSCE"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.chapter != null && _vm.chapter.position === 12) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.chapter != null && _vm.chapter.position === 13) ? _c('a', {
    attrs: {
      "href": "http://www.fosserbia.org",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/fos.png",
      "alt": "FOS Srbija"
    }
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), ([14].indexOf(_vm.chapter.position) !== -1) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "section-title text-center col-12"
  }, [_vm._v(_vm._s(_vm.$t('title.supported')))])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]) : _vm._e(), _vm._v(" "), ([15].indexOf(_vm.chapter.position) !== -1) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "section-title text-center col-12"
  }, [_vm._v(_vm._s(_vm.$t('title.supported')))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row mt-5 text-center",
    staticStyle: {
      "font-size": "0.85rem"
    }
  }, [_c('span', [_vm._v("\n            " + _vm._s(_vm.$t('chapters.15')) + "\n          ")])])]) : _vm._e(), _vm._v(" "), ([16].indexOf(_vm.chapter.position) !== -1) ? _c('div', [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "row mt-5 text-center",
    staticStyle: {
      "font-size": "0.85rem"
    }
  }, [_c('span', [_vm._v("\n            " + _vm._s(_vm.$t('chapters.16')) + "\n          ")])])]) : _vm._e(), _vm._v(" "), ([17].indexOf(_vm.chapter.position) !== -1) ? _c('div', [_c('div', {
    staticClass: "row mb-4"
  }, [_c('h4', {
    staticClass: "section-title text-center col-12"
  }, [_vm._v(_vm._s(_vm.$t('title.supported')))])]), _vm._v(" "), _c('div', {
    staticClass: "row logos"
  }, [_c('div', {
    staticClass: "col-12 mt-12"
  }, [(this.language === 'en') ? _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/logo-unicef-en.png",
      "alt": "UNICEF"
    }
  }) : _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/logo-unicef.png",
      "alt": "UNICEF"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-5 text-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('chapters.17')) + "\n          ")])])]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 offset-md-2"
  }, [_c('a', {
    attrs: {
      "href": "http://www.fren.org.rs",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/logos/fren.png",
      "alt": "FREN"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/logos/ppma.png",
      "alt": "ppma"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('a', {
    attrs: {
      "href": "https://erasmusplus.rs/category/obrazovanje/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/logos/erasmus.png",
      "alt": "ppma"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row logos"
  }, [_c('div', {
    staticClass: "col-12 mt-4"
  }, [_c('a', {
    attrs: {
      "href": "https://cpz.rs/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/cpz.png",
      "alt": "Centar za podršku ženama"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mt-5 text-center",
    staticStyle: {
      "font-size": "0.85rem"
    }
  }, [_c('span', [_c('p', [_vm._v("\n              Teme predstavljene u ovom broju rezultat su istraživanja koje se realizuje u okviru\n              projekta „Uspostavljanje informacionog sistema za prevenciju vršnjačkog nasilja – 3.\n              faza“, koji sprovodi Udruženje građanki i građana “Centar za podršku ženama”, a\n              finansira Ministarstvo omladine i sporta Republike Srbije.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Stavovi izraženi u ovom materijalu isključiva su odgovornost autora i njegovih\n              saradnika i ne predstavljaju zvaničan stav Ministarstva omladine i sporta.\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row logos"
  }, [_c('div', {
    staticClass: "col-4 mt-4"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/nemacka-saradnja.png",
      "alt": "Nemačka saradnja"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-4 mt-4"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/sdc.png",
      "alt": "SDC"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-4 mt-4"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/giz.png",
      "alt": "GIZ"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row logos"
  }, [_c('div', {
    staticClass: "col-12 mt-12"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/c-16-logos-1.png",
      "alt": "Partneri logoi 1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-16"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/c-16-logos-2.png",
      "alt": "Partneri logi 2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c9ac193"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingView.vue
// module id = 501
// module chunks = 1